import {SIDENAV_COLUMN_GAP} from 'quickstart/components/layout/SideNav/styles'
import styled, {
  breakpoints,
  css,
  system,
  SystemProps,
  th,
} from 'quickstart/styled-components/system'
import {cssVars} from 'quickstart/styled-components/theme/base/fonts'

type DigestSize = 'small' | 'medium' | 'large'

type GroupProps = Omit<SystemProps, 'background' | 'foreground' | 'size'> & {
  $background?: string
  $foreground?: string
  $linkColor?: string
  $size?: DigestSize
}

export const Group = styled.div.attrs<GroupProps>(
  ({$size = 'large'}) =>
    ({
      'data-size': $size,
    }) as any,
)<GroupProps>(
  ({$background, $foreground, $linkColor}) => css`
    display: grid;
    gap: ${SIDENAV_COLUMN_GAP};

    &[data-size='small'] {
      grid-template-columns: repeat(2, minmax(0, 1fr));
      ${breakpoints({
        sm: css`
          grid-template-columns: repeat(3, minmax(0, 1fr));
        `,
        md: css`
          grid-template-columns: repeat(4, minmax(0, 1fr));
        `,
        lg: css`
          grid-template-columns: repeat(5, minmax(0, 1fr));
        `,
      })};
    }

    &[data-size='medium'] {
      grid-template-columns: minmax(0, 1fr);
      ${breakpoints({
        sm: css`
          grid-template-columns: repeat(2, minmax(0, 1fr));
        `,
        md: css`
          grid-template-columns: repeat(3, minmax(0, 1fr));
        `,
        lg: css`
          grid-template-columns: repeat(4, minmax(0, 1fr));
        `,
      })};
    }

    &[data-size='large'] {
      grid-template-columns: minmax(0, 1fr);
      ${breakpoints({
        sm: css`
          grid-template-columns: repeat(2, minmax(0, 1fr));
        `,
      })};
    }

    background: ${$background};
    color: ${$foreground};
    ${$linkColor &&
    css`
      ${cssVars.colors.link}: ${$linkColor};
    `};

    ${system};
  `,
)

export const Digest = styled.div`
  display: flex; // for <Digest as={UniversalLink} />
  flex-direction: column;
  word-break: break-word;
`

export const Heading = styled.div`
  text-wrap: balance;
  ${th('digests.default.heading')};
  ${Group}[data-size='small'] & {
    ${th('digests.small.heading')};
  }
  ${Group}[data-size='medium'] & {
    ${th('digests.medium.heading')};
  }
`

export const Snippet = styled.div`
  ${th('digests.default.snippet')};
  ${Group}[data-size='small'] & {
    ${th('digests.small.snippet')};
  }
  ${Group}[data-size='medium'] & {
    ${th('digests.medium.snippet')};
  }
`
